<template>
  <ValidationObserver slim v-slot="{ handleSubmit }">
    <v-card elevation="0" style="height: calc( 100vh - 200px);overflow-y:auto">
      <v-card-text>
        <v-container>
          <h1 class="mb-5">ENCUESTA</h1>
          <h2 class="accent--text mb-2">
                Datos de quien captura (mamá o papá)
              </h2>
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                name="Código Postal"
               
                :rules="{ required: id_colonia >=0, min:5 }"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Código Postal"
                  v-model="codigo_postal"
                  v-mask="'#####'"
                  :error-messages="errors"
                  @keyup="buscarColonia"
                  filled
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                name="Colonia"
                rules="required"
                
                v-slot="{ errors }"
              >
                <v-select
                  v-model="id_colonia"
                  label="Colonia"
                  :items="lst_colonias"
                  item-text="colonia"
                  item-value="id_colonia"
                  :loading="load_colonia"
                  
                  :error-messages="errors"
                  filled
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4" v-if="id_colonia == 0">
              <validation-provider
                name="Otra colonia"
                :rules="{ required: id_colonia === 0 }"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="colonia_otro"
                  label="Otra colonia"
                  prepend-inner-icon="mdi-map-marker"
                  :error-messages="errors"
                  class="my-mayus"
                  filled
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <validation-provider
                name="Edad"
                rules="required|numeric|min_value:15|max_value:120"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Edad"
                  v-model="edad"
                  type="number"
                  min="18"
                  max="120"
                  :error-messages="errors"
                  filled
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                  name="Sexo"
                  rules="required"
                  v-slot="{ errors }"
                >
              <label>Sexo</label>
              <v-radio-group v-model="sexo" row class="pt-0 mt-0" :error-messages="errors">
                <v-radio label="MASCULINO" value="M"></v-radio>
                <v-radio label="FEMENINO" value="F"></v-radio>
              </v-radio-group>
               </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="recibir_informacion"
                label="¿Desea recibir por correo más información del Lux?"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h2 class="accent--text">
                Medio por el cuál se enteró sobre la apertura de admisiones:
              </h2>
            </v-col>
          </v-row>

          <v-divider class="mt-5"></v-divider>
          <v-row>
            <v-col cols="12">
              <v-card class="mb-5" v-for="(medio, i) in lst_medios" :key="i">
                <v-card-title class="accent lighten-4 py-1">{{
                  medio.tipo_medio
                }} </v-card-title>
                <v-card-text class="pb-0 pt-2">
                  
                  <v-item-group v-model="medios" multiple>
                    <v-row justify="start">
                      <v-col
                        cols="12" lg="2" md="6" sm="6"
                        v-for="child in medio.childs"
                        :key="child.id_medio"
                      >
                        <v-item
                          v-slot:default="{ active, toggle }"
                          :value="parseInt(child.id_medio)"
                        >
                       
                          <v-card
                            outlined
                            :class="{ active: active, 'accent--text': active }"
                            height="100"
                            @click="toggle"
                            class="d-flex flex-column justify-center align-center pa-2"
                            style="word-break: break-word"
                          >
                            <h4>{{ child.nombre }}</h4>
                            <v-btn
                              v-if="active"
                              icon
                              class="align-self-end btn-check-encuesta"
                              color="primary"
                            >
                              <v-icon>mdi-check-circle</v-icon>
                            </v-btn>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-item-group>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title class="accent lighten-4 py-1">Otro</v-card-title>
                <v-card-text>
                  <div class="text_otros">
                    <v-text-field
                      v-model="medio_otro"
                      class="my-mayus"
                      label="Otro medio..."
                    ></v-text-field>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="mobil-btn">
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" class="mr-3 white--text px-4" style="background: linear-gradient(0deg, rgba(112,112,112,1) 0%, rgba(156,153,153,1) 100%);" rounded large @click="dialogRegresar = true">
          <v-icon class="mr-2">mdi-arrow-left</v-icon>REGRESAR
        </v-btn>
        <v-btn :disabled="loading" class="mr-3 white--text px-4" style="background: linear-gradient(0deg, rgba(241,37,53,1) 0%, rgba(255,105,105,1) 100%)" rounded large @click="dialogSalir = true">
          <v-icon class="mr-2">mdi-close-box</v-icon>SALIR
        </v-btn>
        <v-btn
        :loading="loading"
          style="background: linear-gradient(0deg, rgba(255,182,0,1) 0%, rgba(255,219,130,1) 100%)"
             rounded
             large
          class="black--text px-4"
          @click="handleSubmit(guardar)"
          v-if="id_encuesta === 0"
        >
          <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
        </v-btn>
        <v-btn
          v-else
          :loading="loading"
          style="background: linear-gradient(0deg, rgba(117,2,173,1) 0%, rgba(159,105,186,1) 100%)"
             rounded
             large
          class="white--text px-4"
          @click="handleSubmit(actualizar)"
        >
          <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- REGISTRO CREADO -->
    <v-dialog v-model="dialog" width="450" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Registro actualizado con éxito
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Tu información del <b>paso 3</b> ha sido guardada.
            </p>
            <p class="text-justify">Clic en [ACEPTAR] para continuar.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="bachillerato"
            dark
            @click="$emit('emit-next', 4), (dialog = false)"
          >
            <v-icon>mdi-check</v-icon>
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SALIR -->
    <v-dialog v-model="dialogSalir" width="450" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Salir
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>no continuar</b> con la captura?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark @click="dialogSalir = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn
            class="bachillerato"
            dark
            @click="$emit('emit-salir'), (dialogSalir = false)"
          >
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / SALIR -->

    <!-- REGRESAR -->
    <v-dialog v-model="dialogRegresar" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Regresar
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>regresar</b> al <b>paso 2</b>?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark @click="dialogRegresar = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn
            class="bachillerato"
            dark
            @click="$emit('emit-last', 2), (dialogRegresar = false)"
          >
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
       <v-snackbar
          v-model="snackbar"
          :vertical="true"
          shaped
          color="error"
          centered
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
    <!-- / REGRESAR -->
  </ValidationObserver>
  
</template>

<script setup>
import { onMounted, ref,getCurrentInstance } from 'vue';
import uniqBy from "lodash/uniqBy";
import axios from "axios";
import { mask } from "vue-the-mask";
import isEmpty from "lodash/isEmpty";

const root=getCurrentInstance().proxy


    const id_encuesta=ref(0)
    const id_precaptura=ref('') // Get session storage
    const codigo_postal=ref('')
    const id_colonia=ref(null)
    const colonia_otro=ref('')
    const medio_otro=ref('')
    const edad=ref(null)
    const sexo=ref(null)
    const recibir_informacion=ref(true)
    const ejemplo=ref([])
    const lst_medios=ref([])
    const medios=ref([])
    const lst_colonias=ref([{ id_colonia: 0, colonia: "No encuentro mi colonia..." }])
    const menu=ref(false)
    const load_colonia=ref(false)
    const text=ref('');
    const snackbar= ref(false);
    const dialog=ref(false)
    const dialogSalir=ref(false)
    const dialogRegresar=ref(false)
 
    const loading=ref(false)

    

    onMounted(()=>{
    console.log('carga encuesta inicia...')
    
    id_precaptura.value = root.$ls.get("id", 0);
    console.log('id_precaptura:',id_precaptura)
    
    getmedios();
    console.log('paso:',root.$ls.get("paso", 0))
    if(root.$ls.get("paso", 0) > 0)getEncuesta();    
    })

    async function getEncuesta() {
      let id_precaptura = root.$ls.get("id", 0);
      let { data, status } = await axios.get(
        `precaptura/encuesta/${id_precaptura}`
      );

      if (status === 200) {
        id_encuesta.value = data.id_encuesta;
        codigo_postal.value = data.codigo_postal==0?"":data.codigo_postal;
        id_colonia.value = parseInt( data.id_colonia );
        colonia_otro.value = id_colonia.value === 0 ? data.colonia : "";
        edad.value = data.edad;
        sexo.value = data.sexo;
        recibir_informacion.value = parseInt(data.recibir_informacion);
        medios.value = data.medios.map( ( i ) => parseInt( i.id_medio ) );
        //console.log(medios.value,data.medios.map( ( i ) => parseInt( i.id_medio ) ));
        medio_otro.value = data.medio_otro;
        buscarColonia();
      }
    }

    async function buscarColonia() {
      if (codigo_postal.value.toString().length === 5) {
        load_colonia.value = true;
        let { data } = await axios.get(
          `direccion/${codigo_postal.value}`
        );
        load_colonia.value = false;
        if (data.length === 0) id_colonia.value = 0;
        data.push({ id_colonia: 0, colonia: "No encuentro mi colonia..." });
        lst_colonias.value = data;
      }
    }

    async function getmedios() {
      let { data } = await axios.get("precaptura/getMedio");

      let medios = uniqBy(data, "id_tipo_medio").map((i) => ({
        id_medio: i.id_medio,
        tipo_medio: i.tipo_medio,
        childs: data
          .filter((ii) => ii.id_tipo_medio === i.id_tipo_medio)
          .map((ii) => ({
            nombre: ii.nombre,
            id_medio: ii.id_medio,
          })),
      }));

      lst_medios.value = medios;
    }

    async function guardar() {
      if(isEmpty(medios.value) && medios.value.length==0 && medio_otro.value==""){
        text.value="Debes seleccionar al menos un medio";
        snackbar.value= true;
        return
      }
      let dataSend={
        codigo_postal:codigo_postal.value,
        edad:edad.value,
        sexo:sexo.value,
        recibir_informacion:recibir_informacion.value,
        id_colonia:id_colonia.value,
        colonia_otro:colonia_otro.value,
        id_precaptura:id_precaptura.value,
        medios:medios.value,
        medio_otro:medio_otro.value,
      }

      loading.value = true;
      let { data, status } = await axios.post("precaptura/encuesta", dataSend);

      loading.value = false;

      if (status === 201) {
        if (data > 0) dialog.value = true;
      }
    }

    async function actualizar() {
       if(isEmpty(medios.value) && medios.value.length<1){
         text.value="Debes seleccionar al menos un medio";
         snackbar.value= true;
        return
      }
      let dataSend={
        codigo_postal:codigo_postal.value,
        edad:edad.value,
        sexo:sexo.value,
        recibir_informacion:recibir_informacion.value,
        id_colonia:id_colonia.value,
        colonia_otro:colonia_otro.value,
        id_precaptura:id_precaptura.value,
        medios:medios.value,
        medio_otro:medio_otro.value,
      }

      loading.value = true;
      let { data, status } = await axios.put(
        `precaptura/encuesta/${id_encuesta.value}`,dataSend);
      loading.value = false;

      if (status === 200) {
        if (data > 0) dialog.value = true;
      }
    }

</script>
<style scoped>

.text_otros{
  width: 45%
}

@media (max-width: 600px) {
.active {  
  border-color: var(--v-primary-base);
}

.btn-check-encuesta {
  bottom: 0;
  right: 0;
  position: absolute;
}

.mobil-btn{
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.mobil-btn button{
  width: 100%;
  margin-left: 0!important;
  margin-right: 0!important;
}

.text_otros{
  width: 100%
}

}
</style>